import React, { useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { WebPhoneProviderV2, useWebPhoneContextV2 } from '../../contexts/WebPhoneContextV2';
import { AuthProvider } from '../../contexts/AuthContext';
import WebPhoneStandaloneV2 from './WebPhoneStandaloneV2';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Inner component that has access to WebPhone context
const WebPhonePopupContent: React.FC = () => {
  const { callStatus } = useWebPhoneContextV2();

  useEffect(() => {
    // Set document title
    document.title = 'WebPhone V2';
  }, []);

  useEffect(() => {
    // Warn user on reload/close if there's an active call
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (callStatus === 'calling' || callStatus === 'ringing' || callStatus === 'in-call') {
        e.preventDefault();
        // Modern browsers show their own message, but we set returnValue anyway
        e.returnValue = 'Your call will be disconnected if you continue.';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [callStatus]);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <WebPhoneStandaloneV2 />
    </Box>
  );
};

const WebPhonePopupV2: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <WebPhoneProviderV2>
          <WebPhonePopupContent />
        </WebPhoneProviderV2>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default WebPhonePopupV2;
